import {createFileRoute} from '@tanstack/react-router';
import {AuthSignInPage} from '@/features/auth';
import {authSignedGuard, can} from '@/libs/router';

export const Route = createFileRoute('/_auth/auth/signin')({
  beforeLoad: can([authSignedGuard]),
  loader: () => ({
    staffId: '',
  }),
  component: () => <AuthSignInPage />,
});
